import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchAllSeasonPlayerRankings } from '../../../services/PlayerStatService';
import Loading from '../../../components/Loading';
import { SeasonRankings } from '../../../types/types';
import AchievementShowcase from './AchievementShowcase';
import SeasonRow from './SeasonRow';
import './achievements.css';

const PlayerAchievementsDisplay: React.FC = () => {
    const { steamId } = useParams<{ steamId?: string }>();
    const [seasons, setSeasons] = useState<number[]>([]);
    const [rankings, setRankings] = useState<SeasonRankings>({});
    const [loading, setLoading] = useState<boolean>(false);

    const fetchRankingsAndSeasons = useCallback(async () => {
        setLoading(true);
        if (!steamId) {
            console.error('Steam ID is undefined');
            setLoading(false);
            return;
        }
        try {
            const rankingsData = await fetchAllSeasonPlayerRankings(steamId);
            const groupedRankings = rankingsData.reduce((acc, ranking) => {
                if (!acc[ranking.season]) {
                    acc[ranking.season] = [];
                }
                acc[ranking.season].push(ranking);
                return acc;
            }, {} as SeasonRankings);
            setSeasons(Object.keys(groupedRankings).map(Number).sort((a, b) => b - a));
            setRankings(groupedRankings);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [steamId]);

    useEffect(() => {
        fetchRankingsAndSeasons();
    }, [fetchRankingsAndSeasons]);

    if (loading) {
        return <Loading />;
    }

    if (!rankings || seasons.length === 0) {
        return <div className="achievements-empty">Ingen placeringer fundet</div>;
    }

    return (
        <div className="achievements-container">
            <AchievementShowcase rankings={rankings} seasons={seasons} />

            <div className="achievements-seasons">
                {seasons.map((season) => (
                    <SeasonRow
                        key={season}
                        season={season}
                        rankings={rankings[season] || []}
                    />
                ))}
            </div>
        </div>
    );
};

export default PlayerAchievementsDisplay;
